import { createFileRoute } from "@tanstack/react-router";
import { VortexAuthAcceptInvitePage } from "@vortexnyc/vortex-core/auth/react";

import {
  authRoutePaths,
  toSafeRedirectPath,
  useAppAuthActions,
} from "../integrations/vortex-auth/runtime";

// Invitation landing route. Reads the invitation token from the URL, then hands
// off to the shared vortex-auth runtime actions (buildSignUpUrl /
// redirectToSignIn) so the invite flows through the standard sign-up surface.
// No plasma backend lookup is wired here — token redemption happens in the
// post-sign-up flow (F4 scope); this route only routes the user into auth.
export const Route = createFileRoute("/accept-invite")({
  component: AcceptInvitePage,
});

function AcceptInvitePage() {
  const actions = useAppAuthActions();

  return (
    <VortexAuthAcceptInvitePage
      buildSignUpUrl={actions.buildSignUpUrl}
      postSignUpPath={authRoutePaths.postSignUpPath}
      redirectToSignIn={actions.redirectToSignIn}
      signInPath={authRoutePaths.signInPath}
      signUpPath={authRoutePaths.signUpPath}
      toSafeRedirectPath={toSafeRedirectPath}
    />
  );
}
